export default "__VITE_ASSET__C3GNwrZc__"